import { render, staticRenderFns } from "./DrawerChangelog.vue?vue&type=template&id=bcefd41e&scoped=true&"
import script from "./DrawerChangelog.vue?vue&type=script&lang=js&"
export * from "./DrawerChangelog.vue?vue&type=script&lang=js&"
import style0 from "./DrawerChangelog.vue?vue&type=style&index=0&id=bcefd41e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcefd41e",
  null
  
)

export default component.exports